import { UAParser } from 'ua-parser-js'

export const getDeviceInfos = () => UAParser(navigator.userAgent)
